import { EQ } from 'framework-listing-lib/utils/filters';
import { AutomationPlatformFlowProperties } from 'automation-ui-management/constants/CrmWorkflowProperties';
export const hiddenFiltersForFolder = {
  filterGroups: [{
    filters: [EQ(AutomationPlatformFlowProperties.DELETED, false), EQ(AutomationPlatformFlowProperties.IS_EXTERNAL_FLOW, false)]
  }]
};